import { EBusinessProviders } from '@/components/BusinessTypeSelector/business-providers.enum';

export type FormWebhookFakeFidel = {
  businessId: string;
  emailCustomer: string;
  eventType: string;
  amount: number;
  externalTransactionId?: string | null;
};

export type FormManuallyReward = {
  businessId: string;
  emailCustomer: string;
  amount: number;
  transactionDate: string;
};

export enum ECoinStatus {
  ACTIVE = 'active',
  READY = 'ready',
  PENDING = 'pending',
  NOT_GIVEN = 'not-given'
}

export enum ERefundStatus {
  TOTAL = 'total',
  PARTIAL = 'partial',
  DONE = 'done'
}

export enum EConnectTransactionStatus {
  AUTHORIZED = 'authorized',
  CLEARED = 'cleared',
  PROVISIONAL = 'provisional',
  CREATED = 'created'
}

export type TransactionTableListAdmin = {
  amount: string;
  businessName: string;
  cardNumber: string;
  coinsAmount: string;
  coinsNotGivenReason: string | null;
  createdAt: Date;
  coinsStatus: ECoinStatus;
  customerName: string;
  id: string;
  isClearLate: string;
  provider: EBusinessProviders;
  rawData: {
    businessId: string;
    externalTransactionId: string;
    customer: {
      id: string;
      lastname: string;
      mail: string;
      name: string;
    };
  };
  refundStatus: string | null;
  status: EConnectTransactionStatus;
  updatedAt: Date;
};
